import { h, Component } from 'preact';

import style from './style.less';

import { configure } from '../../../config';
import { getLastGamePlayed } from '../../../lib/game';

import { Icon } from '@cube/blocks';


/** Creates promo for a game based on last game played or random suggestion
 */
@configure({
	gamePromotion: 'singleCube.gamePromotion'
})
export class GamePromotion extends Component {


	getRandomInt(max) {
		return Math.floor(Math.random() * max);
	}

	componentWillMount() {
		// Get from local storage first
		let game = getLastGamePlayed();

		if (!game) {
			//build it from config
			game = this.props.gamePromotion.games[this.getRandomInt(this.props.gamePromotion.games.length)];
			game.display = this.props.gamePromotion.text[this.getRandomInt(this.props.gamePromotion.text.length)] + ' : ' + game.title;
		}
		else {
			game.display = 'Play Again : ' + game.title;
		}

		this.setState({ game });
	}

	render({ }, { game }) {
		if (!game) return;

		return (
			<div class={style.gamePromotion}>
				<a href={`/games/play/canonical/${game.id}/vendor/Arkadium`}>
					<div>
						<Icon name="games-wire-cube" />
					</div>
					<div class={style.display}>
						{game.display}
					</div>
					<div>
						<Icon name="navigate-right-cube" />
					</div>
				</a>
			</div>
		);
	}
}
